import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IModalState } from './model'

const selectModalFeat = createFeatureSelector<Readonly<IModalState>>('modal');

export const selectModalState = createSelector(
    selectModalFeat,
    (state: IModalState) => state
);